var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isUserEntry)?_c('Leaderboard_Entry_User',{attrs:{"data":_vm.data,"display-type":_vm.displayType,"highlighted":_vm.highlighted}}):(_vm.isSeparatorEntry)?_c('Leaderboard_Entry_Separator'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }